import { createAction, props } from '@ngrx/store';
import { Document } from '../../../core/store/models/document.model';
import { View } from '../workflow/workflow.model';
import { DocumentQueryParams, QueryParams, QueryResult } from '../../../core/store/models/query.model';
import { FilterGroup } from 'src/app/modules/core/store/models';
//
// Data Page actions
//
export const newDocument = createAction('[Data/Page] New Document');
export const newDocumentComplete = createAction('[Data/Page] New Document Complete', props<{ view: View; document: Document }>());
export const editDocument = createAction('[Data/Page] Edit Document', props<{ document: Document }>());
export const editDocumentComplete = createAction('[Data/Page] Edit Document Complete', props<{ view: View; document: Document }>());
export const cancelEditDocument = createAction('[Data/Page] Cancel Edit Document');
export const saveDocument = createAction('[Data/Page] Save Document', props<{ document: Document; isNewDocument: boolean }>());
export const saveDocumentComplete = createAction('[Data/Page] Save Document Complete', props<{ document: Document }>());
export const setDocumentForDelete = createAction('[Data/Page] Set Document for Delete', props<{ document: Document }>());
export const deleteSelectedDocument = createAction('[Data/Page] Delete Selected Document');
export const clearDocumentForDelete = createAction('[Data/Page] Clear Document for Delete');
export const setError = createAction('[Data/Page] Set Error', props<{ err: any }>());
export const setSearchTerm = createAction('[Data/Page] Set Search Term', props<{ searchTerm: string }>());
export const paginateList = createAction('[Data/Page] Paginate Document List', props<{ skip: number }>());
export const resetState = createAction('[Data/Page] Reset State');

//
// Data API actions
//
export const createDocument = createAction('[Data/API] Create Document', props<{ document: Document }>());
export const updateDocument = createAction('[Data/API] Update Document', props<{ document: Document }>());
export const getDocuments = createAction('[Data/API] Get Documents');
export const getDocumentsComplete = createAction('[Data/API] Get Documents Complete', props<{ results: QueryResult<Document> }>());

export const clearDatasetData = createAction('[Data/Page] Delete Dataset Data');
export const clearDatasetDataComplete = createAction('[Data/Page] Delete Dataset Data Complete');

export const updateDocumentWfStep = createAction('[Data/API] Update Workflow Step in Documents');
export const updateDocumentWfStepComplete = createAction('[Data/API] Update Workflow Step in Documents Complete');

export const setDocumentQueryParams = createAction('[Data/API] set Document Query Params', props<{ query: DocumentQueryParams }>());
